import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "uD93er",
    defaultMessage: "Changed Customer",
    description: "dialog header",
  },
  description: {
    id: "Zg0dRo",
    defaultMessage:
      "You have changed customer assigned to this order. What would you like to do with the shipping address?",
    description: "dialog description",
  },
  keepAddress: {
    id: "iue6mV",
    defaultMessage: "Keep address",
    description: "option label",
  },
  changeAddress: {
    id: "s6lW8R",
    defaultMessage: "Change address",
    description: "option label",
  },
});

export default messages;
